import { cn } from '../../lib/utils';

interface BadgeProps {
  children: React.ReactNode;
  variant?: 'default' | 'outline' | 'secondary' | 'success' | 'warning' | 'destructive';
  className?: string;
}

export function Badge({ children, variant = 'default', className }: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center px-2 py-1 rounded-md text-xs font-medium',
        variant === 'default' &&
          'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-300',
        variant === 'outline' &&
          'border border-gray-200 dark:border-gray-700 bg-transparent text-gray-700 dark:text-gray-300',
        variant === 'secondary' &&
          'bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-200',
        variant === 'success' &&
          'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300',
        variant === 'warning' &&
          'bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-300',
        variant === 'destructive' &&
          'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-300',
        className
      )}
    >
      {children}
    </span>
  );
}

